import React, { Fragment } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';
import formatedDate, { formattedDateTime } from '../../../../../utilities/formatedDate';
import { Warning } from '@mui/icons-material';


const DocumentDetails = ({ data,invoice,createdDetails }) => {
    console.log(data, 'document data')

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Document Number</th>
                                <td className="text-right pr-5">
                                    {data?.document_unique_code ? data?.document_unique_code : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Booking Id</th>
                                <td className="text-right pr-5">
                                    {data?.travellers?.[0]?.certificate_number ? data?.travellers?.[0]?.certificate_number : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Invoice Number</th>
                                <td className="text-right pr-5">
                                    {invoice?.invoice_number ? invoice?.invoice_number : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Sale Date</th>
                                <td className="text-right pr-5">
                                    {data?.created_at ? formattedDateTime(data?.created_at) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Start Date</th>
                                <td className="text-right pr-5">
                                    {data?.travel_start_date ? formatedDate(data?.travel_start_date) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>End Date</th>
                                <td className="text-right pr-5">
                                    {data?.travel_end_date ? formatedDate(data?.travel_end_date) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Created At</th>
                                <td className="text-right pr-5">
                                    {data?.created_at ? formattedDateTime(data?.created_at) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Create By</th>
                                <td className="text-right pr-5">
                                    {createdDetails?.name ? createdDetails?.name : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td className="text-right pr-5">
                                    <Badge color={data?.status  === 'ACTIVE' ? 'success' : data?.status == 'CANCELLED' ? 'danger' : 'warning'}>
                                        {data?.status }
                                    </Badge>
                                </td>
                            </tr>
                            <tr>
                                <th>Cancellation Reason</th>
                                <td className="text-right pr-5">
                                  
                                        {data?.cancellation_reason || '-'}
                                    
                                </td>
                            </tr>
                            <tr>
                                <th>Cancellation Date</th>
                                <td className="text-right pr-5">
                                     {data?.cancellation_date ? formatedDate(data?.cancellation_date) : '-' }
                                </td>
                            </tr>
                            <tr>
                                <th>Cancellation Remark</th>
                                <td className="text-right pr-5">
                                   
                                        {data?.cancellation_remarks || '-' }
                                  
                                </td>
                            </tr>
                            <tr>
                                <th>Cancellation By Role</th>
                                <td className="text-right pr-5">
                                   
                                        {data?.cancelled_by_role || '-'}
                                    
                                </td>
                            </tr>
                            <tr>
                                <th>Cancellation By User</th>
                                <td className="text-right pr-5">
                                    
                                        {data?.cancelledByUser?.name || '-'}
                                  
                                </td>
                            </tr>
                            {/* <tr>
                                <th>Plan Status</th>
                                <td className="text-right pr-5">
                                    <Badge color={data?.plan?.is_active === true ? 'success' : 'danger'}>
                                        {data?.plan?.is_active ? 'Active' : 'Deactivate'}
                                    </Badge>
                                </td>
                            </tr> */}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default DocumentDetails;